<div class="steps-list d-flex justify-content-between align-items-center w-100">
  <!-- Numbers of steps before the current step -->
  <div class="d-flex justify-content-start flex-shrink-0">
    @for (step of steps; track step; let i = $index) {
      <div class="{{ i === activeStep ? 'active-step' : i < activeStep && showProgress ? 'completed-step' : 'inactive-step' }}" (click)="setStep(i)">
        @if (stepIcons.length) {
          @if (i < activeStep) {
            <span class="mts-icon step-icon">{{stepIcons[i]}}</span>
          }
        }
        @if (!stepIcons.length) {
          @if (i < activeStep) {
            <span class="step-number d-flex justify-content-center align-items-center fs-small">
              {{ i + 1 }}
            </span>
          }
        }
      </div>
    }
  </div>

  <!-- Current step and title -->
  <div class="d-flex flex-grow-1 active-step align-items-center">
    @if (stepIcons.length) {
      <span class="mts-icon step-icon">{{stepIcons[activeStep]}}</span>
    }
    @if (!stepIcons.length) {
      <span class="step-number me-2 d-flex justify-content-center align-items-center fs-small">{{ activeStep + 1 }}</span>
    }
    <span class="step-title fs-small truncate-text-one-line">{{ steps[activeStep] }}</span>
  </div>

  <!-- Remaining steps numbers -->
  <div class="d-flex justify-content-end flex-shrink-0">
    @for (step of steps; track step; let i = $index) {
      <div class="{{ i === activeStep ? 'active-step' : i < activeStep && showProgress ? 'completed-step' : 'inactive-step' }}" (click)="setStep(i)">
        @if (stepIcons.length) {
          @if (i > activeStep) {
            <span class="mts-icon step-icon">{{stepIcons[i]}}</span>
          }
        }
        @if (!stepIcons.length) {
          @if (i > activeStep) {
            <span class="step-number d-flex justify-content-center align-items-center fs-small">
              {{ i + 1 }}
            </span>
          }
        }
      </div>
    }
  </div>
</div>
